
// interface propsTypes {
//     verificationUserId: React.Dispatch<React.SetStateAction<number>>

import axiosInstance from "@/lib/axiosInstance";
import axios from "axios";
import { useState } from "react";
import { useRouter } from 'next/navigation';

// }
type propsTypes = {
    verificationUserId: number | null,
}
type ErrorObject = {
    [key: string]: string;
}
// Correctly defined function
const OtpVerification = ({ verificationUserId }: propsTypes) => {
    const router = useRouter()
    const [formData, setFormData] = useState({
        otp: '',
        id: ''
    });
    const [errors, setErrors] = useState<ErrorObject>({});

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };

    // Handle form submission with proper typing
    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        // Handle form submission logic here
        try {
            formData.id = `${verificationUserId}`;
            const response = await axiosInstance.post('api/users/signup-otp-verification',
                formData,
            );
            router.push('/login?m=success')
        } catch (error) {
            if (axios.isAxiosError(error)) {
                // validation error 
                let errorObject: ErrorObject = {};
                if (error?.response?.status) {
                    let errorArray = error?.response?.data?.error;
                    // Convert the array of objects to a single object
                    if (Array.isArray(errorArray))
                        errorObject = errorArray.reduce((acc: any, cur: any) => ({ ...acc, ...cur }), {});
                    else if (typeof error.response.data === 'object')
                        errorObject = error.response.data;
                    else
                        errorObject = { general: error.response.data };
                }
                setErrors(errorObject);
            }
        }
    };

    return (
        <div className="container border md:mt-14 rounded-md md:pt-10 pb-14">
            <h2 className="text-3xl font-playfair mt-5">Sign up Verification</h2>
            <hr className="my-3" />
            <form onSubmit={handleSubmit}>
                <div className="grid md:grid-cols-1 py-5 gap-x-5 gap-y-4">

                    <div className="p-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400" role="alert">
                        Please check your email for 6 digit verification code.
                    </div>
                    <div className="p-4 text-sm text-green-800 rounded-lg bg-green-50 dark:bg-gray-800 dark:text-green-400" role="alert">
                        Also, we have sent an activation link  by clicking you can verify your registration.
                    </div>

                    <div>
                        <label htmlFor="confirmPassword">
                            Verification Code:
                        </label>
                        <input className="border rounded-sm py-2 px-2 outline-none w-full block"
                            type="text"
                            name="otp"
                            id="fName"
                            placeholder="Verification Number"
                            value={formData.otp}
                            onChange={handleChange}
                        />
                        {errors?.otp && <p className='text-red-500'>{errors.otp}</p>}
                        {errors?.error && <p className='text-red-500'>{errors.error}</p>}
                    </div>

                    <div>
                        <button className="capitalize mt-0 py-2 px-4 bg-[#43c6ac] hover:bg-[#60D3BD] text-white tracking-wider">Submit</button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default OtpVerification;